

export class UserConversation {

  constructor(public id: string,
              public participantId: string,
              public unread: number = 0,
              public status: number = 0) {

  }

  static fromAngularFireSnapshots(snapshots: any) : UserConversation[] {
    return snapshots.map(snap => UserConversation.fromSnapshot(snap.key, snap.payload.val()));
  }

  static fromSnapshot(key: string, {status, unread, conversationId}) {
    return new UserConversation(conversationId, key, unread, status);
  }

}



// WEBPACK FOOTER //
// ./src/providers/communication/models/UserConversation.ts